import { settingResource } from '@witkac/kartamiejska-resources';
import {
  Setting,
  settingValueType,
  SettingValueType,
  Declination
} from '@witkac/kartamiejska-shared';

/**
 * Moduł danych systemowych
 *
 * @export
 * @class SystemModule
 */
export class SystemModule {
  /**
   * Czy ma być używany namespace
   *
   * @type {boolean}
   * @memberof SystemModule
   */
  public namespaced: boolean = true;

  /**
   * Stan store
   *
   * @type {object}
   * @memberof SystemModule
   */
  public state: any = {
    // wersja kompilacji
    packageVersion: process.env.PACKAGE_VERSION,
    // data kompilacji
    buildDate: process.env.PACKAGE_BUILD_DATE,
    appTitle: 'Obsługa użytkownika karty',
    // Nazwa karty
    cardName: {
      mianownik: 'Karta Mieszkańca',
      dopelniacz: 'Karty Mieszkańca',
      celownik: 'Karcie Mieszkańca',
      biernik: 'Kartę Mieszkańca',
      narzednik: 'Kartą Mieszkańca',
      miejscownik: 'Karcie Mieszkańca'
    }
  };

  public mutations = {
    /**
     * Zapisuje dane profilu do store
     *
     * @param localState state
     * @param data dane ustawienia
     */
    setCardName(localState: any, data: Declination): void {
      localState.cardName = data;
    }
  };

  public actions = {
    /**
     * Pobiera ustawienie
     *
     * @param context context
     * @param id identyifkator encji
     */
    loadCardName: async (context: any, code: string): Promise<Declination> => {
      const response = await settingResource.settingFindPublic('CARD_NAME');
      const jsonData = JSON.parse(response.value);
      context.commit('setCardName', jsonData.data);
      return jsonData.data;
    }
  };
}

export default new SystemModule();
